import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Menu } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import ModalAddCategory from './components/ModalAddCategory';
import CookieManagementService from '../../services/CookieManagement.service';
import useNotify from '../../context/Notification/useNotify';
import ModalDelete from '../../components/Shared/modal/delete';
import usePermission from '../../hooks/usePermission';

export default function CategoryList({
    categoryList,
    setSelectCategory,
    selectCategory,
    domainList,
    domainSelect,
    getCookieCategoryList,
    loadingStatus,
}) {
    const { t, i18n } = useTranslation();
    let lang = i18n.language;
    const notify = useNotify();
    const [showModal, setShowModal] = useState(false);
    const [cagetoryDetail, setCagetoryDetail] = useState();
    const [cagetoryIdDelete, setCagetoryIdDelete] = useState();

    // ConfirmDelete
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);

    const menu = (item) =>
        item?.categoryNameEn === 'Necessary' ||
        item?.categoryNameEn === 'Analytics' ||
        item?.categoryNameEn === 'Marketing' ? (
            <Menu
                className="w-28"
                items={[
                    {
                        label: t('common.Edit'),
                        key: '1',
                        onClick: () => {
                            setShowModal(true);
                            setCagetoryDetail(item);
                        },
                    },
                ]}
            />
        ) : (
            <Menu
                className="w-28"
                items={[
                    {
                        label: t('common.Edit'),
                        key: '1',
                        onClick: () => {
                            setShowModal(true);
                            setCagetoryDetail(item);
                        },
                    },
                    {
                        label: t('common.Delete'),
                        key: '2',
                        onClick: () => {
                            setCagetoryIdDelete(item?.cookieCategoryId);
                            setOpenConfirmDelete(true);
                        },
                    },
                ]}
            />
        );

    useEffect(() => {
        setSelectCategory(categoryList?.general[0]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { isAuditor, isUser } = usePermission();

    return (
        <>
            {loadingStatus === true && (
                <>
                    <div className="rounded-md w-[100%] space-y-3  mt-6">
                        <div className="text-[#65707A] text-[12px] font-semibold">
                            {t('COOKIE.CookieCategory')}
                        </div>
                        <div
                            className="my-1"
                            style={{ borderBottom: '1px solid #F2F2F2' }}
                        ></div>
                        {categoryList?.general?.map((e) => (
                            <button
                                key={e.cookieCategoryId}
                                className="relative cursor-pointer w-full text-left"
                                onClick={() => {
                                    setSelectCategory(e);
                                }}
                            >
                                <div
                                    className={`p-3 text-[14px] font-medium hover:border-solid hover:border-[1px] hover:border-[#7B67FB]
                                        ${
                                            selectCategory?.cookieCategoryId ===
                                            e.cookieCategoryId
                                                ? 'text-[#FFFFFF] bg-[#7B67FB] border-solid border-[1px] border-[#7B67FB]'
                                                : 'text-[#7B67FB] bg-[#F4F6FC] border-solid border-[1px] border-[#F4F6FC]'
                                        }  rounded-md`}
                                >
                                    {lang === 'en'
                                        ? e.categoryNameEn
                                        : e.categoryNameTh}
                                </div>
                                <div className="absolute top-2 right-2">
                                    <Dropdown
                                        disabled={isAuditor || isUser}
                                        overlay={menu(e)}
                                        trigger={['click']}
                                        className="disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        <button
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            {svgIcon}
                                        </button>
                                    </Dropdown>
                                </div>
                            </button>
                        ))}

                        <button
                            disabled={isAuditor || isUser}
                            type="button"
                            hidden={categoryList?.general?.length >= 10}
                            onClick={() => setShowModal(true)}
                            style={{ border: '1px dashed #7B67FB' }}
                            className="disabled:opacity-50 disabled:cursor-not-allowed bg-[#F4F6FC] rounded-md text-purple flex items-center py-5 px-4 mb-2 h-10 text-sm font-medium space-x-2 cursor-pointer w-full"
                        >
                            <PlusOutlined />
                            <span>{t('COOKIE.AddCategory')}</span>
                        </button>
                    </div>

                    <div className="rounded-md w-[100%] space-y-3  mt-6">
                        <div className="text-[#65707A] text-[12px] font-semibold">
                            {t('CookieCategory.CookieUnclassified')}
                        </div>
                        <div
                            className="my-1"
                            style={{ borderBottom: '1px solid #F2F2F2' }}
                        ></div>
                        {categoryList?.unclassify?.map((e) => (
                            <button
                                type="button"
                                key={e.cookieCategoryId}
                                className="relative cursor-pointer w-full text-left"
                                onClick={() => setSelectCategory(e)}
                            >
                                <div
                                    className={`p-3 text-[14px] font-medium hover:border-solid hover:border-[1px] hover:border-[#7B67FB]
                                        ${
                                            selectCategory?.cookieCategoryId ===
                                            e.cookieCategoryId
                                                ? 'text-[#FFFFFF] bg-[#7B67FB] border-solid border-[1px] border-[#7B67FB]'
                                                : 'text-[#7B67FB] bg-[#F4F6FC] border-solid border-[1px] border-[#F4F6FC]'
                                        }  rounded-md`}
                                >
                                    {lang === 'en'
                                        ? e.categoryNameEn
                                        : e.categoryNameTh}
                                </div>
                            </button>
                        ))}
                    </div>
                </>
            )}
            <ModalAddCategory
                open={showModal}
                handelClose={() => setShowModal(false)}
                setCagetoryDetail={setCagetoryDetail}
                cagetoryDetail={cagetoryDetail}
                domainList={domainList}
                domainSelect={domainSelect}
                getCookieCategoryList={getCookieCategoryList}
            />
            <ModalDelete
                title={t('common.ConfirmDelete')}
                text={t('COOKIE.DoYouWantToDeleteCategory')}
                open={openConfirmDelete}
                handelOk={async () => {
                    try {
                        const { data } =
                            await CookieManagementService.deleteCookieCategory(
                                cagetoryIdDelete
                            );
                        if (data?.resultCode === 1) {
                            setOpenConfirmDelete(false);
                            notify({
                                title: t('common.Success'),
                                description: t('Successfully deleted data'),
                            });
                            getCookieCategoryList(
                                domainSelect?.companyId,
                                domainSelect?.domainId
                            );
                        } else {
                            if (
                                data?.errorData?.msg ===
                                'COOKIE CATEGORY HAVE DETAIL'
                            ) {
                                setOpenConfirmDelete(false);
                                notify({
                                    type: 'error',
                                    title: t('COOKIE.FailDeleteCategory'),
                                    description: t(
                                        'COOKIE.FailDeleteCategoryTitle'
                                    ),
                                    timeOut: 120000,
                                    closeable: true,
                                });
                            } else {
                                setOpenConfirmDelete(false);
                                notify({
                                    type: 'error',
                                    title: t('common.Fail'),
                                    description: t('common.FailedDeleteData'),
                                    timeOut: 120000,
                                    closeable: true,
                                });
                            }
                        }
                    } catch (err) {
                        setOpenConfirmDelete(false);
                        notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('common.FailedDeleteData'),
                            timeOut: 120000,
                            closeable: true,
                        });
                    }
                }}
                handelClose={() => setOpenConfirmDelete(false)}
            />
        </>
    );
}

const svgIcon = (
    <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="30" height="30" rx="6" fill="#EEE5FF" />
        <path
            d="M18.5156 15C18.5156 15.9668 19.3066 16.7578 20.2734 16.7578C21.2402 16.7578 22.0312 15.9668 22.0312 15C22.0312 14.0332 21.2402 13.2422 20.2734 13.2422C19.3066 13.2422 18.5156 14.0332 18.5156 15Z"
            fill="#7B67FB"
        />
        <path
            d="M16.7578 15C16.7578 14.0332 15.9668 13.2422 15 13.2422C14.0332 13.2422 13.2422 14.0332 13.2422 15C13.2422 15.9668 14.0332 16.7578 15 16.7578C15.9668 16.7578 16.7578 15.9668 16.7578 15Z"
            fill="#7B67FB"
        />
        <path
            d="M11.4844 15C11.4844 14.0332 10.6934 13.2422 9.72656 13.2422C8.75977 13.2422 7.96875 14.0332 7.96875 15C7.96875 15.9668 8.75977 16.7578 9.72656 16.7578C10.6934 16.7578 11.4844 15.9668 11.4844 15Z"
            fill="#7B67FB"
        />
    </svg>
);
